module.exports = __webpack_public_path__ + "assets/fonts/20f5ee8b6c176625a06ad92fcdafea37.woff";